import { MenuAction } from '@ordr-as/umami-react/context-menu';
import { FormattedMessage } from 'react-intl';

interface Props {
  onClick: () => void;
}

const LogOut = ({ onClick }: Props) => {
  return (
    <MenuAction className="h-[68px] !py-3 border-b border-grey-lightest" onClick={onClick}>
      <div className="flex flex-col text-left">
        <span className="text-base text-brand-black">
          <FormattedMessage id="header.Logout" />
        </span>
        <span className="text-sm text-grey-dark break-words max-w-[70vw] sm:max-w-none">
          <FormattedMessage id="header.logoutInfo" />
        </span>
      </div>
    </MenuAction>
  );
};

export default LogOut;
